import React, { memo } from 'react';
import { ListItem } from '@mui/material';
import classnames from 'classnames';
import { makeStyles } from '@mui/styles';
import { TimeSignal } from 'graphql/types';
import {
  NoteListItemContent,
  useListStyles,
  useStyles
} from '../../notes/list/NoteListItem';

interface NoteListItemDragPreviewStyleProps {
  width: number;
  height: number;
  isItemUncategorized: boolean;
  isItemScrolled: boolean;
}

const useNoteListItemDragPreviewStyles = makeStyles((theme) => ({
  root: {
    width: ({ width }: NoteListItemDragPreviewStyleProps) => `${width}px`,
    height: ({ height }: NoteListItemDragPreviewStyleProps) => `${height}px`,
    backgroundColor: theme.palette.common.white,
    opacity: 0.8
  },
  spacing: {
    minWidth: ({ isItemUncategorized }: NoteListItemDragPreviewStyleProps) =>
      theme.spacing(isItemUncategorized ? 10 : 10.875)
  }
}));

export type NoteListItemDragPreviewProps = {
  note: TimeSignal;
  isItemUncategorized: boolean;
  isItemScrolled: boolean;
  width: number;
  height: number;
};

export const NoteListItemDragPreview: React.FC<NoteListItemDragPreviewProps> = memo(
  ({
    note,
    isItemUncategorized,
    isItemScrolled,
    width,
    height
  }: NoteListItemDragPreviewProps) => {
    const classes = useStyles({
      isItemUncategorized: isItemUncategorized,
      isItemGrouped: true,
      isTIWebGroupViewEnabled: true,
      excluded: false,
      isItemScrolled: isItemScrolled
    });
    const noteListItemDragPreviewClasses = useNoteListItemDragPreviewStyles({
      width: width,
      height: height,
      isItemUncategorized: isItemUncategorized,
      isItemScrolled: isItemScrolled
    });

    return (
      <ListItem
        data-testid="note-list-item-drag-preview"
        classes={useListStyles({ isItemGrouped: true })}
        className={classnames(
          classes.root,
          noteListItemDragPreviewClasses.root,
          classes.paper
        )}
      >
        <div className={noteListItemDragPreviewClasses.spacing} />
        <NoteListItemContent
          note={note}
          readOnly={false}
          isItemUncategorized={isItemUncategorized}
          isItemGrouped={true}
          classes={classes}
        />
      </ListItem>
    );
  }
);

NoteListItemDragPreview.displayName = 'NoteListItemDragPreview';
